import {
  LOGGED_OUT_CAT_PAGE_SIZE,
  LOGGED_OUT_CAT_PAGE_SIZE_WITH_NEW_INLINE_BANNER,
} from "@faire/retailer-shared/categories/createRequests/catNavPageSize";
import { useSettingBatch9LoggedOutPagesInlineBanner } from "@faire/retailer-visitor-shared/settings/useSettingBatch9LoggedOutPagesInlineBanner";

export const useLoggedOutCategoryPageRequestPageSize = () => {
  const useNewInlineBanner = useSettingBatch9LoggedOutPagesInlineBanner();
  return useNewInlineBanner
    ? LOGGED_OUT_CAT_PAGE_SIZE_WITH_NEW_INLINE_BANNER
    : LOGGED_OUT_CAT_PAGE_SIZE;
};
